import { themeTools } from "native-base";
const variants = {
    solid: (props) => {
        const { colorScheme: c } = props;
        const token = c === "muted" ? "300" : "500";
        const bgToken = props.bg || `${c}.${token}`;

        return {
            borderWidth: 1,
            borderColor: bgToken,
            _disabled: {
                bg: bgToken,
            }
        }
    },
    ghost_faded: (props) => {
        const { colorScheme: c } = props;
        const token = c === "muted" ? "300" : "500";
        const color = props.color || `${c}.${token}`;

        return {
            color,
            _text: {
                color
            },
            borderWidth: 1,
            bg: themeTools.transparentize(color, .2)(props.theme),
            borderColor: "rgba(0,0,0,0)",
            _hover: {
                color,
                bg: themeTools.transparentize(color, .2)(props.theme),
                borderColor: "rgba(0,0,0,0)",
            },
            _hover: {
                color,
                bg: themeTools.transparentize(color, .2)(props.theme),
                borderColor: "rgba(0,0,0,0)",
            },
            _focusVisible: {
                style: { boxShadow: "" },
                color,
                bg: themeTools.transparentize(color, .3)(props.theme),
                borderColor: "rgba(0,0,0,0)",
            },
            _pressed: {
                color,
                bg: themeTools.transparentize(color, .3)(props.theme),
                borderColor: "rgba(0,0,0,0)",
            },
        }
    },
    ghost: (props) => {
        const { colorScheme: c } = props;
        const token = c === "muted" ? "300" : "500";
        const color = props.color || `${c}.${token}`;

        return {
            borderWidth: 1,
            bg: "transparent",
            color,
            borderColor: "rgba(0,0,0,0)",
            _hover: {
                color,
                borderColor: "rgba(0,0,0,0)",
                bg: themeTools.transparentize(color, .2)(props.theme)
            },
            _focus: {
                color,
                borderColor: "rgba(0,0,0,0)",
                bg: "transparent",
            },
            _focusVisible: {
                style: { boxShadow: "" },
                color,
                borderColor: "rgba(0,0,0,0)",
                bg: themeTools.transparentize(color, .3)(props.theme)
            },
            _pressed: {
                color,
                borderColor: "rgba(0,0,0,0)",
                bg: themeTools.transparentize(color, .3)(props.theme)
            },
        }
    },
    outline: (props) => {
        const { colorScheme: c } = props;
        const token = c === "muted" ? "300" : "500";
        const colorToken = `${c}.${token}`;
        const color = props.color || colorToken;

        return {
            color,
            _text: {
                color
            },
            borderColor: themeTools.mode(colorToken, `${c}.200`)(props),

            _hover: {
                borderColor: themeTools.mode(colorToken, `${c}.200`)(props),
                bg: themeTools.transparentize(themeTools.mode(colorToken, `${c}.400`)(props), 0.2)(props.theme),
            },
            _focus: {
                bg: "transparent",
            },
            _focusVisible: {
                borderColor: themeTools.mode(colorToken, `${c}.200`)(props),
                bg: themeTools.transparentize(themeTools.mode(colorToken, `${c}.400`)(props), 0.3)(props.theme),
            },
            _pressed: {
                borderColor: themeTools.mode(colorToken, `${c}.200`)(props),
                bg: themeTools.transparentize(themeTools.mode(colorToken, `${c}.500`)(props), 0.4)(props.theme),
            },
        }
    }
}

export const ButtonTheme = {
    IconButton: {
        baseStyle: {
            rounded: "xs",
        },
        defaultProps: {
            variant: "ghost",
        },
        variants
    },
    Button: {
        baseStyle: {
            rounded: "sm",
            textTransform: "uppercase",
            fontFamily: 'body',
            fontSize: 'sm',
            _text: {
                fontSize: "inherit",
                fontFamily: 'body',
                textTransform: "uppercase"
            },
            _web: {
                _disabled: {
                    cursor: "not-allowed",
                },
            },
        },

        defaultProps: {
            size: "sm",
            colorScheme: "gray",
            variant: "ghost",
            _spinner: {
                size: "xs",
                marginRight: "1"
            }
        },
        
        variants
    }
}